import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingRing = (props) => {
    const {
        backdrop,
        sxBox,
        sxBackdrop,
        sxCircularProgress
    } = props;

    const backdropStyles = {
        zIndex: (theme) => theme.zIndex.drawer + 1,
        ...sxBackdrop
    };

    const boxStyles = {
        display: 'flex',       
        ...sxBox
    };

    return (backdrop ?
        <Backdrop open sx={backdropStyles}>
            <CircularProgress sx={sxCircularProgress} />
        </Backdrop> :
        <Box sx={boxStyles}>
            <CircularProgress sx={sxCircularProgress} />
        </Box>
    );
};

export default LoadingRing;